export default __webpack_public_path__ + "static/media/pin_icon.4f776d2c.svg";